import React from "react";

export default function CustomInput({
  label,
  type,
  customClass,
  placeholder,
  onChange,
  onBlur,
  name,
  value,
  touched,
  error,
  onKeyPress,
  disabled,
  readOnly,
}) {
  return (
    <div className="common-modal-field">
      <label>{label}</label>
      <input
        disabled={disabled}
        type={type}
        name={name}
        value={value}
        className={`form-control ${customClass}`}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        readOnly={readOnly}
      />
      {touched && error && (
        <p style={{ color: "red", marginBottom: 0 }}>{error}</p>
      )}
    </div>
  );
}
